module.exports = __webpack_public_path__ + "assets/img/jindong_economics_cover.333b784f.png";